<template>
  <div class="login">
    <div class="pic"></div>
    <div class="wrap">
      <p><span></span><span>精密客流分析平台<i>集团端</i></span></p>
      <el-tabs v-model="activeIndex">
        <el-tab-pane label="扫码登录" name="1">
          <div id="wechat"></div>
        </el-tab-pane>
        <el-tab-pane label="账号登录" name="2">
          <el-form ref="form" :model="form" :rules="rules">
            <el-form-item prop="phone">
              <p>手机号</p>
              <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <p>验证码</p>
              <el-input class="code" :class="{'btn-disabled': !code.status}" placeholder="请输入验证码" v-model="form.code" clearable>
                <el-button slot="append" @click="sendCode">{{code.text}}</el-button>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="login" @click="login">登录</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import regex from '@/assets/utils/regex.js';
  import EntranceService from '@/io/entrance.js';
  import CommonService from '@/io/common.js';
  import WechatService from '@/io/wechat.js';

  export default {
    name: 'Login',
    data() {
      let self = this;
      return {
        checkPhone: this.debounce((value, callback) => {
          if (!regex.phone.rule.test(value)) {
            callback(new Error(regex.phone.text));
          } else {
            callback();               
          }
        }, 1000),
        form: {
          phone: '',
          code: ''
        },
        rules: {
          phone: [
            {
              required: true, message: '请输入手机号'
            },
            {
              validator(rule, value, callback) {
                self.checkPhone(value, callback);
              }
            }
          ],
          code: [
            {
              required: true, message: '请输入验证码'
            }
          ]
        },
        code: {
          text: '发送验证码',
          status: true
        },
        activeIndex: '1'
      }
    },
    watch: {
      activeIndex: {
        handler(newValue, oldValue) {
          this.$nextTick(() => {
            if (newValue === '1') {
              WechatService.params().then(res => {
                window.WwLogin({
                  "id": "wechat",  
                  "appid": res.data.corp_id,
                  "agentid": res.data.agent_id,
                  "redirect_uri": encodeURIComponent(`${window.location.origin}/index.html#/wechat_blank`),
                  "state": new Date().getTime(),
                  "href": encodeURIComponent(`${window.location.origin}/wechat.css`),
                });
              }).catch(() => {});
            }
          });
        },
        immediate: true
      }
    },
    methods: {
      startInterval() {
        this.initInterval(
          60,
          time => {
            this.setCodeStatus(false);
            this.setCodeText(`已发送(${time}秒)`);
          },
          () => {
            this.setCodeStatus(true);
            this.setCodeText('重新发送');
          }
        );
      },
      setCodeText(text) {
        this.code.text = text;
      },
      setCodeStatus(status) {
        this.code.status = status;
      },
      sendCode() {
        if (this.code.status) {
          this.$refs.form.validateField(['phone'], res => {
            if (res === '') {
              this.startInterval();
              CommonService.sendCode(
                this.form.phone,
                2
              ).catch(() => {});
            }
          });     
        }
      },
      login() {
        this.$refs.form.validate(res => {
          if (res) {
            EntranceService.login(
              this.form.phone,
              this.form.code
            ).then(res => {
              this.$message.success('登录成功');
              this.$router.replace({
                path: this.$route.query.redirect || '/'
              });
            }).catch(err => {
              if (err.data.code === 200005) {
                this.step = 1;
                this.form.code = '';
                this.setCodeText('发送验证码');
                this.setCodeStatus(true);
              }
              // 我本不想在这里写 目前整体还没有合适的规划
              if (err.data.code === 200012) {
                this.$message.error('权限不足,请联系管理员');
              }
            });
          }
        });
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .login {
    display: flex;
    align-items: center;
    justify-content: center;
    .pic {
      .setImg('/entrance/pic.png');
      margin-right: 75px;
    }
    .wrap {
      width: 320px;
      & > p {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
        span {
          &:nth-of-type(1) {
            .setImg('/common/logo.png');
            width: 40px;
            height: 40px;
            margin-right: 10px;
          }
          &:nth-of-type(2) {
            font-size: 24px;
            font-weight: bold;
            color: @color-text-1;
            position: relative;
            width: 244px;
            i {
              font-size: 12px;
              color: @color-white;
              font-style: normal;
              position: absolute;
              background-color: @color-primary;
              padding: 4px 8px;
              transform: scale(.7);
              font-weight: normal;
              border-radius: 4px;
              top: 1px;
              right: 4px;
            }
          }
        }
      }
    }
    /deep/ .el-tabs {
      .el-tabs__header {
        margin: 0 auto 20px auto;
        .el-tabs__nav-wrap {
          .el-tabs__nav-scroll {
            display: flex;
            justify-content: center;
          }
        }
      }
      .el-tabs__content {
        .el-tab-pane {
          height: 244px;
        }
      }
    }
    #wechat {
      display: flex;
      justify-content: center;
    }
    .el-form {
      .el-form-item {
        .el-form-item__content {
          & > p {
            color: @color-text-3;
            line-height: initial;
            margin-bottom: 10px;
          }
          .login {
            margin-top: 20px;
          }
        }
      }
    }
    /deep/ .code {
      .el-input-group__append {
        color: @color-primary;
        background-color: initial;
        .el-button {
          width: 130px;
        }
      }
      &.btn-disabled {
        .el-input-group__append {
          background-color: initial;
          color: @color-text-4;
        }
      }
    }
    .el-button {
      width: 100%;
    }
  }
</style>